import { DEFAULT_TIMEZONE, FORM_MODES } from '@treneo/shared/constants';
import { useAppTranslations } from '@treneo/shared/i18n';
import { BaseModal } from '@treneo/shared/ui';

import { CourseForm } from '../shared/course-form';
import type { CourseFormData } from '../shared/types';

type Props = {
  open: boolean;
  onClose: () => void;
  onSubmit: (submissionData: CourseFormData) => void;
  isLoading?: boolean;
  isSuccess?: boolean;
};

export const CreateCourseModal = ({
  open,
  onClose,
  onSubmit,
  isLoading = false,
  isSuccess = false
}: Readonly<Props>) => {
  const { t } = useAppTranslations();

  const initialFormData: Partial<CourseFormData> = {
    title: '',
    description: '',
    timezone: DEFAULT_TIMEZONE,
    maxParticipants: 20,
    expectedParticipants: 10,
    daDataCenterIds: [],
    daOrganizationId: 0,
    courseDates: [],
    wantToBeCoordinator: true
  };

  return (
    <BaseModal
      open={open}
      onClose={onClose}
      title={t('createCourseModal.title')}
      maxWidth='1200px'
      sx={{
        '& .MuiPaper-root': {
          margin: '-5rem'
        }
      }}
    >
      <CourseForm
        mode={FORM_MODES.CREATE}
        onSubmit={onSubmit}
        onCancel={onClose}
        isSubmitSuccess={isSuccess}
        isLoading={isLoading}
        initialData={initialFormData}
      />
    </BaseModal>
  );
};
